import React, { Component } from 'react';
import {FaIcon} from "../../FaIcon";
import {Spinner} from "../../Spinner";
import {HELP_MCP, LinkToArticle} from "../../help_center/LinkToArticle";
import { withTranslation } from 'react-i18next';

class MCPStatusClass extends Component {
    render() {
        const { mcp_status_data, t } = this.props;

        if (!mcp_status_data) {
            if(!this.props.hasConnection) {
                return (
                    <div className={"bu-cell-icon fa-icon status-not-included"}>
                    <FaIcon iconName="times-circle" />
                    <div className="bu-tooltip looker-cc-tooltip">
                        <p className="tooltip-description status-no-included">
                            {t('mcp_status.not_included_or_not_connected')}
                        </p>
                    </div>
                </div>
                );
            }

            return (
                <div className={"bu-cell-icon fa-icon status-not-included"}>
                    <FaIcon iconName="times-circle" />
                    <div className="bu-tooltip looker-cc-tooltip">
                        <p className="tooltip-description status-no-included">
                            {t('mcp_status.not_included_tooltip')}<br/><br/>{t('mcp_status.not_included_contact')}<br/><br/>
                            {t('mcp_status.description')}<br/><br />
                            &nbsp;&nbsp;➡️<LinkToArticle article={HELP_MCP}/>
                        </p>
                    </div>
                </div>
            );
        }

        const { status, completed_percentage } = mcp_status_data;

        if (status === "COMPLETE" || (completed_percentage && completed_percentage >= 100)) {
            return (
                <div className={"bu-cell-icon fa-icon status-ok"}>
                    <FaIcon iconName="check-circle"/>
                </div>
            );
        }

        if (status === "PROCESSING") {
            return (
                <div className={"bu-cell-icon fa-icon status-loading"}>
                    <Spinner color="positive small" />
                    <div className="bu-tooltip looker-cc-tooltip">
                        <p className="tooltip-description">
                            {t('mcp_status.processing_tooltip', { percentage: completed_percentage || 0 })} <br/><br/>
                            {t('mcp_status.processing_connection_issue')}<br/>
                            {t('mcp_status.processing_contact')}
                        </p>
                    </div>
                </div>
            );
        }

        return (
            <div className={"bu-cell-icon"}>
                <FaIcon iconName={"exclamation-triangle"} />
                 <div className="bu-tooltip">
                    <p className="tooltip-description">
                        {t('mcp_status.unknown_status')}
                    </p>
                </div>
            </div>
        );
    }
}

export const MCPStatus = withTranslation()(MCPStatusClass);
